export default __webpack_public_path__ + "static/media/Drain-Repair-.e9412600.jpg";